import React, { useState, useEffect } from "react";
import ReactTable from "common/components/ReactTable/ReactTable";
import { useGetProductsSummaryQuery } from "features/api/reports/reportsSlice";
import { FilterFields } from "../Components/types";
import Header from "../Components/Header";
import { getProductsTableColumns } from "../utils";

const ProductsReport = () => {
  const [filterValues, setFilterValues] = useState<FilterFields[]>([]);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState([]);
  const excelEndpoint = `GetProductsSummaryAsExcelFile`;

  const filtersNotIncluded = [
    "coordinates",
    "modelType",
    "carColor",
    "commentToSeniorController",
    "commentToPolice",
  ];

  const submitFilter = (filters: FilterFields[]) => {
    setFilterValues(filters);
    setPageIndex(1);
  };

  const filterObject = filterValues.reduce(
    (acc, cur) =>
      // eslint-disable-next-line no-nested-ternary
      // cur.field !== "tags"
      cur.field === "createdOn" ||
      cur.field === "updateOn" ||
      cur.field === "volunteerSendDate"
        ? { ...acc, [cur.field]: `${cur.startDate}-${cur.endDate}` }
        : { ...acc, [cur.field]: cur.value },
    // : { ...acc, [cur.field]: [cur.value] },
    {}
  );

  const { data: producstSummaryData, isFetching } = useGetProductsSummaryQuery({
    page: pageIndex,
    filter: filterObject,
  });

  const columns = getProductsTableColumns;

  useEffect(() => {
    if (!isFetching && producstSummaryData) {
      setData(producstSummaryData.objectList || []);
      setPageCount(producstSummaryData.totalPages || 0);
    }
  }, [producstSummaryData, isFetching]);

  useEffect(() => {
    setPageIndex(1); // Reset to first page when filters change
  }, [filterValues]);

  return (
    <div style={{ paddingBottom: 20 }}>
      <Header
        columns={columns.filter(
          (col) => !filtersNotIncluded.includes(col.accessor)
        )}
        exportColumns={columns}
        submitFilter={submitFilter}
        filterValues={filterValues}
        thereIsData={data?.length > 0}
        excelEndpoint={excelEndpoint}
      />
      <ReactTable
        data={data}
        columns={columns}
        pageIndex={pageIndex}
        setPageIndex={setPageIndex}
        pageCount={pageCount}
      />
    </div>
  );
};

export default ProductsReport;
